




















import { Component, Prop, Vue } from "vue-property-decorator";
import dateranges from "@/data/dateranges";

@Component
export default class SelectRangeAndGroupModal extends Vue {
  @Prop({ required: true })
  public dateFrom!: Date;

  @Prop({ required: true })
  public dateTo!: Date;

  @Prop({ default: false })
  public time!: boolean;

  public inner_dates: Date[] = [this.dateFrom, this.dateTo] || [];

  public get preselectOptions() {
    return this.$_.toArray(dateranges.ranges);
  }

  public apply() {
    const option = this.preselectOptions.find(option => {
      const isSame = (a, b) =>
        this.$moment(a[0]).isSame(b[0], "day") &&
        this.$moment(a[1]).isSame(b[1], "day");
      return this.$_.isEqualWith(
        [option.dateFrom, option.dateTo],
        this.inner_dates,
        isSame
      );
    });

    this.$emit("update", {
      ...option,
      dateFrom: this.inner_dates[0],
      dateTo: this.inner_dates[1],
      group: this.$_.get(option, "group", null)
    });
    this.$nextTick(() => {
      this.$emit("close");
    });
  }
}
